module.exports = __webpack_public_path__ + "static/media/md-basketball.f0bd29bb.svg";